import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

import { useResponsive } from 'contexts/ResponsiveContext';
import { useUserProfile } from 'contexts/UserProfileContext';

import UserEditForm from './components/UserEditForm/UserEditForm';
import UserProfile from './components/UserProfile/UserProfile';
import useProfilePage from './hooks/useProfilePage';

const ProfilePage: FC = () => {
  const { isMobile } = useResponsive();
  const { handleSubmitForm, handleDeleteImgBtnClick } = useProfilePage();
  const { userProfile } = useUserProfile();

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Toolbar />
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.paper',
          px: { xs: 3, sm: 6, md: 8 },
          py: { xs: 3, sm: 4, md: 5 },
        }}
      >
        <Typography variant="h4" color="text.primary" fontWeight={700} sx={{ mb: 4 }}>
          Profile
        </Typography>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: { xs: 4, md: 8 },
          }}
        >
          <Box sx={{ position: 'relative', flexShrink: 0 }}>
            <UserProfile />
            {userProfile?.photoUrl && (
              <IconButton
                aria-label="Delete image"
                onClick={handleDeleteImgBtnClick}
                sx={{ position: 'absolute', top: 32, left: 180 }}
              >
                <CloseIcon />
              </IconButton>
            )}
          </Box>

          {userProfile && <UserEditForm onSubmit={handleSubmitForm} />}
        </Box>
      </Box>
    </Box>
  );
};

export default ProfilePage;
